import MenuIntegracoes from "../MenuIntegracoes";
import Footer from "../Footer";
import NavbarTop from "../NavbarTop";
import MenuInicioRapido from "../MenuInicioRapido";
import React, { useEffect, useState } from "react";
import PesquisaArtigo from "../PesquisaArtigo";

export default function IntegracaoMeta() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollButton && window.pageYOffset > 400) {
        setShowScrollButton(true);
      } else if (showScrollButton && window.pageYOffset <= 400) {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScrollButton]);

  useEffect(() => {
    // Rola a página para o topo sempre que a página é carregada
    window.scrollTo(0, 0);
  }, []); // Executa o efeito apenas uma vez, quando o componente é montado

  return (
    <>
      <section>
        <div>
          <NavbarTop />
        </div>

        <div className="container col-md-11">
          <div className="row content section paddingt-2 white-background">
            <div className="col-md-12">
              <nav aria-label="breadcrumb" role="navigation">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <a href="/integracoes">Integrações</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Como conectar minha conta do Facebook ou Instagram?
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row justify-content-between">
            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuIntegracoes />
            </div>

            <div className="col-md-6">
              <h1 className="article-heading">
                Como conectar minha conta do Facebook ou Instagram?
              </h1>
              <hr />

              <div className="row justify-content-between" id="article-meta">
                <div className="author col-6 pl-5">
                  <span className="author-name">Integrações</span>
                </div>
                <small className="col-6 text-right pr-5">
                  Conecte sua rede social
                </small>
              </div>
              <hr />

              <div className="content article-content">
                <br></br>

                <p>
                  Para integrar sua conta Meta à <a> </a>
                  <a
                    href="https://salesbox.com.br/plataforma.html"
                    target="blank"
                  >
                    Plataforma Sales Box
                  </a>
                  <a> </a>é necessário informar seu usuário e senha do facebook
                </p>

                <p>
                  <h3>Primeiro Passo</h3>
                </p>

                <p>
                  Clique em seu nome de usuário no topo do menu lateral direito
                  e em seguida clique em "Integrações".
                </p>

                <figure>
                  <img src="img/integracao.png" alt="integracao" />
                </figure>

                <figcaption>Minha Conta - Integração</figcaption>

                <p>
                  <h3>Segundo Passo</h3>
                </p>

                <p>Clique no quadro Facebook e Instagram</p>

                <figure>
                  <img src="img/connect.png" alt="integracao" />
                </figure>

                <figcaption>Minha Conta - Integração</figcaption>

                <p>
                  <h3>Terceiro Passo</h3>
                </p>

                <p>Um novo Pop Up aparecerá. Clique em Conectar.</p>

                <figure>
                  <img src="img/conectar.png" alt="integracao" />
                </figure>

                <figcaption>Minha Conta - Integração</figcaption>

                <p>
                  <h3>Quarto Passo</h3>
                </p>

                <p>
                  Um Pop Up do Facebook de Login será exibido. Neste processo,
                  você autoriza a <a> </a>
                  <a
                    href="https://salesbox.com.br/plataforma.html"
                    target="blank"
                  >
                    Sales Box
                  </a>
                  <a> </a>a conectar nas suas contas de anúncios permitindo com
                  que posts e campanhas sejam realizada de forma segura e
                  devidamente autenticada.
                </p>

                <figure>
                  <img src="img/login-fb.png" alt="integracao" />
                </figure>

                <figcaption>Conectar</figcaption>

                <p>
                  <h3>Quinto Passo</h3>
                </p>

                <p>
                  Siga os passos para seleção das suas contas de anúncio.
                  Finalizando o processo, aparecerá na tela Facebook e Instagram
                  Conectado
                </p>

                <figure>
                  <img src="img/connected.png" alt="integracao" />
                </figure>

                <figcaption>Conectar</figcaption>

                <br></br>
              </div>

              {/* Seção de votos */}

              <div>
                <PesquisaArtigo />
              </div>
            </div>

            <div className="col-md-3 text-left d-none d-md-inline-block">
              <MenuInicioRapido />
            </div>
          </div>
        </div>
      </section>

      {showScrollButton && (
        <a onClick={scrollToTop} className="btn-topo">
          <a style={{ fontSize: "25px" }}>↑</a> Voltar ao Topo
        </a>
      )}

      <Footer />
    </>
  );
}
